/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * OrganizationBrandingDtoBase
 * auto generated base class for the model OrganizationBrandingDtoModel.
 */
export const OrganizationBrandingDtoModelBase = ModelBase
  .named('OrganizationBrandingDto')
  .props({
    __typename: types.optional(types.literal("OrganizationBrandingDto"), "OrganizationBrandingDto"),
    name: types.union(types.undefined, types.null, types.string),
    logoUrl: types.union(types.undefined, types.null, types.string),
    address: types.union(types.undefined, types.null, types.string),
    phoneNumber: types.union(types.undefined, types.null, types.string),
    customerFacingEmail: types.union(types.undefined, types.null, types.string),
    website: types.union(types.undefined, types.null, types.string),
    brandColor: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrganizationBrandingDtoModelSelector extends QueryBuilder {
  get name() { return this.__attr(`name`) }
  get logoUrl() { return this.__attr(`logoUrl`) }
  get address() { return this.__attr(`address`) }
  get phoneNumber() { return this.__attr(`phoneNumber`) }
  get customerFacingEmail() { return this.__attr(`customerFacingEmail`) }
  get website() { return this.__attr(`website`) }
  get brandColor() { return this.__attr(`brandColor`) }
}
export function selectFromOrganizationBrandingDto() {
  return new OrganizationBrandingDtoModelSelector()
}

export const organizationBrandingDtoModelPrimitives = selectFromOrganizationBrandingDto().name.logoUrl.address.phoneNumber.customerFacingEmail.website.brandColor
